import { css } from '@emotion/css';

export const titleWithBannerStyles = css`
  p,
  h2 {
    color: var(--text-white) !important;
    -webkit-text-fill-color: var(--text-white) !important; //safari color issue
  }

  -webkit-text-fill-color: var(--text-white) !important; //safari color issue
`;
export const languageSelectorStyles = css`
  .MuiInputBase-root.MuiOutlinedInput-root {
    background: transparent;
    min-width: 200px;
  }
  .MuiInputBase-input.MuiOutlinedInput-input {
    color: var(--text-white);
  }
`;
